import { Link } from 'react-router-dom';

const styles = `
  .gd { --green:#1B4332; --green2:#2D6A4F; --mint:#6ee7b7; --bg:#F5F2EC; --card:#FDFCF9; --dark:#1A1A18; --mid:#4A4A45; --light:#8A8A82; --border:#E2DDD4; --warnlt:#FEF3C7; --warn:#B45309;
        --serif:'Fraunces', Georgia, serif; --sans:'DM Sans', sans-serif;
        font-family:var(--sans); background:var(--bg); color:var(--dark); line-height:1.7; min-height:100vh; display:flex; flex-direction:column; }
  .gd *, .gd *::before, .gd *::after { box-sizing:border-box; }
  .gd a { color:inherit; }
  .gd a:focus-visible, .gd .btn:focus-visible { outline:2px solid var(--green2); outline-offset:3px; border-radius:4px; }
  .gd nav { background:var(--dark); padding:16px 48px; display:flex; justify-content:space-between; align-items:center; position:sticky; top:0; z-index:100; }
  .gd .logo { font-family:var(--serif); font-size:22px; font-weight:300; color:#fff; text-decoration:none; }
  .gd .logo em { color:var(--mint); }
  .gd .nav-links { display:flex; gap:20px; align-items:center; }
  .gd .nav-links a { color:rgba(255,255,255,.7); font-size:14px; text-decoration:none; }
  .gd .nav-links a:hover { color:#fff; }
  .gd nav a:focus-visible { outline-color:var(--mint); }
  .gd .btn { display:inline-block; padding:10px 20px; border-radius:8px; font-weight:600; font-size:14px; text-decoration:none; white-space:nowrap; }
  .gd .btn-mint { background:var(--mint); color:#0f2e22 !important; }
  .gd .btn-mint:hover { background:#86efc5; }
  .gd .btn-outline { border:1.5px solid rgba(255,255,255,.3); color:#fff !important; }
  .gd main { flex:1; width:100%; padding:56px 24px 72px; }
  .gd .wrap { max-width:720px; margin:0 auto; }
  .gd .wrap-wide { max-width:1000px; margin:0 auto; }
  .gd .crumbs { font-size:13px; color:var(--light); margin-bottom:20px; }
  .gd .crumbs a { color:var(--mid); text-decoration:underline; text-underline-offset:3px; }
  .gd h1 { font-family:var(--serif); font-weight:300; font-size:clamp(32px,5vw,46px); line-height:1.15; margin-bottom:14px; }
  .gd .meta { font-size:14px; color:var(--mid); margin-bottom:36px; padding-bottom:24px; border-bottom:1px solid var(--border); }
  .gd h2 { font-family:var(--serif); font-weight:300; font-size:clamp(24px,3.4vw,30px); line-height:1.25; margin:44px 0 14px; }
  .gd p { font-size:17px; color:#2b2b28; margin-bottom:18px; }
  .gd ul, .gd ol { margin:0 0 22px 22px; }
  .gd li { font-size:17px; color:#2b2b28; margin-bottom:10px; padding-left:4px; }
  .gd li::marker { color:var(--green2); }
  .gd strong { font-weight:600; }
  .gd article a, .gd .sources a { color:var(--green); text-decoration:underline; text-underline-offset:3px; }
  .gd .note { background:var(--warnlt); border-left:3px solid var(--warn); border-radius:6px; padding:14px 18px; margin:0 0 22px; font-size:15px; color:#5b3a06; }
  .gd .note p { font-size:15px; color:inherit; margin:0; }
  .gd .cta-box { background:var(--green); color:#fff; border-radius:14px; padding:32px; margin:48px 0 36px; }
  .gd .cta-box h2 { color:#fff; margin:0 0 8px; font-size:26px; }
  .gd .cta-box p { color:rgba(255,255,255,.75); font-size:16px; margin-bottom:20px; }
  .gd .sources { margin-top:36px; padding-top:24px; border-top:1px solid var(--border); }
  .gd .sources h2 { font-size:20px; margin:0 0 10px; }
  .gd .sources li { font-size:15px; margin-bottom:6px; }
  .gd .disclaimer { font-size:13px; color:var(--light); margin-top:20px; }
  .gd .related { margin-top:36px; }
  .gd .related h2 { font-size:20px; margin:0 0 10px; }
  .gd .related li { font-size:16px; }
  .gd .guide-list { display:grid; grid-template-columns:repeat(auto-fit,minmax(290px,1fr)); gap:20px; margin-top:32px; }
  .gd .guide-card { display:block; background:var(--card); border:1.5px solid var(--border); border-radius:12px; padding:24px; text-decoration:none; transition:border-color .15s; }
  .gd .guide-card:hover { border-color:var(--green2); }
  .gd .guide-card h2 { font-size:21px; margin:0 0 8px; line-height:1.3; }
  .gd .guide-card p { font-size:15px; color:var(--mid); margin:0 0 12px; line-height:1.55; }
  .gd .guide-card span { font-size:13px; color:var(--light); }
  .gd footer { background:var(--dark); padding:36px 48px; display:flex; justify-content:space-between; align-items:center; flex-wrap:wrap; gap:16px; }
  .gd footer p { color:rgba(255,255,255,.5); font-size:13px; margin:0; }
  .gd .footer-links { display:flex; gap:22px; flex-wrap:wrap; }
  .gd .footer-links a { color:rgba(255,255,255,.55); font-size:13px; text-decoration:none; }
  .gd .footer-links a:hover { color:#fff; }
  @media (max-width: 720px) {
    .gd nav { padding:14px 16px; }
    .gd .logo { font-size:18px; }
    .gd .nav-links { gap:12px; }
    .gd .btn { padding:9px 14px; font-size:13px; }
    .gd main { padding:36px 20px 56px; }
    .gd p, .gd li { font-size:16px; }
    .gd .cta-box { padding:24px 20px; }
    .gd footer { padding:28px 20px; flex-direction:column; text-align:center; }
  }
  @media (max-width: 400px) { .gd .nav-cta { display:none; } }
`;

export default function GuideLayout({ children }) {
  return (
    <div className="gd">
      <style>{styles}</style>
      <nav aria-label="Main">
        <Link to="/" className="logo">Landlord<em>Comply</em></Link>
        <div className="nav-links">
          <Link to="/guides">Guides</Link>
          <Link to="/login" className="btn btn-outline">Sign in</Link>
          <Link to="/signup" className="btn btn-mint nav-cta">Start free trial</Link>
        </div>
      </nav>

      <main>{children}</main>

      <footer>
        <span className="logo" style={{ fontSize: 18 }}>Landlord<em>Comply</em></span>
        <p>© 2026 LandlordComply. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/guides">Guides</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </footer>
    </div>
  );
}
